<template>
  <div>
    <a-modal
      v-bind="attrs"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      :centered="true"
      @cancel="cancel"
    >
      <a-form
        :model="states.formState"
        name="addWorkflow"
        ref="formRef"
        layout="vertical"
        :rules="rules"
        autocomplete="off"
        class="mt-20 mb-20"
      >
        <a-form-item label="智能体名称" name="workflowName">
          <a-input v-model:value="states.formState.workflowName"> </a-input>
        </a-form-item>
        <a-form-item label="智能体描述" name="description">
          <a-input v-model:value="states.formState.description" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { Modal as AModal, Form as AForm, Input as AInput, message } from 'ant-design-vue'
import { ref, reactive, useAttrs, getCurrentInstance, toRaw, watch } from 'vue'
import {
  addWorkFlowApi,
  editWorkFlowApi,
  copyWorkFlowApi,
  getIsDuplicateNameApi
} from '@/service/api/workFlow.js'
import { cloneDeep } from 'lodash'

const AFormItem = AForm.Item

const props = defineProps({
  type: {
    type: String,
    default: ''
  },
  init: {
    type: Object,
    default: () => {}
  }
})

const emits = defineEmits(['asyncSuccess'])
const { proxy } = getCurrentInstance()
const initForm = {
  workflowName: '',
  id: '',
  // workflowIcon: 'FileTextOutlined',
  description: '',
  workflowCode: '',
  workflowTypeCode: ''
}
const rules = {
  workflowName: [
    {
      required: true,
      message: '不能为空',
      trigger: 'change'
    },
    {
      max: 24,
      message: '长度不可超过24个字符',
      trigger: 'blur'
    }
  ],
  description: [
    {
      max: 200,
      message: '长度不可超过200个字符',
      trigger: 'blur'
    }
  ]
}
const attrs = useAttrs()
const states = reactive({
  formState: cloneDeep(initForm)
})
const confirmLoading = ref(false)
const formRef = ref()

const cancel = () => {
  states.formState = cloneDeep(initForm)
}
const handleOk = () => {
  formRef.value
    .validate()
    .then(() => {
      confirmLoading.value = true
      if (props.type === 'addWorkFlowRepeat') {
        getIsDuplicateNameApi({
          workflowInfoName: states.formState.workflowName
        }).then((res) => {
          if (res.data) {
            message.error('复制失败，名字重复。')
            confirmLoading.value = false
          } else {
            copyWorkFlowApi({
              ...toRaw(states.formState),
              workflowDescription: states.formState.description
            }).then((res) => {
              if (res.data) {
                message.success('复制成功')
                cancel()
                emits('asyncSuccess')
                proxy.$EventBus.emit('addWorkflowMitt')
              }
              confirmLoading.value = false
            })
          }
        })
      } else if (props.type === 'workBench') {
        // 我的工作台 编辑保存
        console.log('states.formState', states.formState)
        editWorkFlowApi({
          ...toRaw(states.formState)
        }).then((res) => {
          console.log(res)
          if (res.data) {
            message.success('编辑成功')
            cancel()
            emits('asyncSuccess')
            proxy.$EventBus.emit('addWorkflowMitt')
          }
          confirmLoading.value = false
        })
      } else if (props.type === 'addWorkFlow') {
        getIsDuplicateNameApi({
          workflowInfoName: states.formState.workflowName
        }).then((res) => {
          if (res.data) {
            message.error('新增失败，名字重复。')
            confirmLoading.value = false
          } else {
            copyWorkFlowApi({
              ...toRaw(states.formState)
            }).then((res) => {
              if (res.data) {
                message.success('新增成功')
                cancel()
                emits('asyncSuccess')
                proxy.$EventBus.emit('addWorkflowMitt')
              }
              confirmLoading.value = false
            })
          }
        })
      } else {
        const handle =
          typeof attrs.open === 'object' || attrs.open === 'workBench'
            ? editWorkFlowApi
            : addWorkFlowApi
        handle({
          ...toRaw(states.formState)
        }).then((res) => {
          console.log(res)
          if (res.data) {
            message.success(typeof attrs.open === 'object' ? '编辑成功' : '新增成功')
            cancel()
            emits('asyncSuccess')
            proxy.$EventBus.emit('addWorkflowMitt')
          }
          confirmLoading.value = false
        })
      }
    })
    .catch(() => {})
}
watch(
  () => attrs.open,
  (val) => {
    if (props.type === 'workBench') {
      initForm.workflowName = props.init.title
      initForm.description = props.init.description
      initForm.id = props.init.id
      initForm.workflowCode = props.init.code
      initForm.workflowTypeCode = props.init.workflowTypeCode
    }
    console.log('props.init', props.init)

    states.formState = typeof val === 'object' ? cloneDeep(val) : cloneDeep(initForm)
  }
)
</script>
